import React, { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import IdentifyPage from 'researcher/application/components/IdentifyPage';
import GlobalLoading from 'researcher/components/GlobalLoading';
import { redirectToVerification } from 'shared/helper/email-verification-redirect';

/**
 * Hands a sign-up verification link (`/:lang/verify-email/:token`) back to megatron, so the link in
 * the email can carry the Rubriq domain the researcher registered on rather than megatron's.
 *
 * Megatron owns the token: it records the verification and then redirects on to
 * `/:lang/login?emailVerification=...`, which is what tells the researcher whether the link worked,
 * had already been used, or had expired. Nothing is decided here.
 *
 * This is a full page navigation rather than an XHR because megatron answers with a redirect, and
 * because the researcher arrives with whatever the email client sent - no application state of ours
 * is worth preserving across it.
 */
var EmailVerificationRedirect = function EmailVerificationRedirect() {
  var _useParams = useParams(),
    token = _useParams.token;
  // React StrictMode invokes effects twice in development. Redirecting twice would spend the token
  // on the first navigation and show the second one an already-verified link.
  var redirecting = useRef(false);
  useEffect(function () {
    if (redirecting.current) {
      return;
    }
    redirecting.current = true;
    redirectToVerification(token);
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IdentifyPage, {
    robots: "noindex, nosnippet, noarchive",
    title: "Rubriq"
  }), /*#__PURE__*/React.createElement(GlobalLoading, {
    className: "position-relative"
  }));
};
export default EmailVerificationRedirect;